
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsroom/food-safety",
      function () {
        return require("private-next-pages/newsroom/food-safety.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsroom/food-safety"])
      });
    }
  